// OROMA menu data — preserves the exact order, names, descriptions, and prices from the brief.
export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_oroma-experience/artifacts/0gfd2w1e_cd8b712b-af20-4501-a2b7-38debfe68922.jpeg",
  hero: "https://customer-assets.emergentagent.com/job_oroma-experience/artifacts/9hlx29ig_IMG_5187.jpeg",
  interior: "https://customer-assets.emergentagent.com/job_oroma-experience/artifacts/b3f0xiod_IMG_5189.jpeg",
  pendant: "https://customer-assets.emergentagent.com/job_oroma-experience/artifacts/cy38k13e_IMG_5188.jpeg",
  cookies: "https://customer-assets.emergentagent.com/job_oroma-experience/artifacts/vwo0xk1j_IMG_5190.png",
};

export const FEATURED_CATEGORIES = [
  {
    id: "cold-brews",
    title: "Cold Brews",
    description: "Slow-steeped, sun-chasing, shamelessly easy to sip.",
    image: ASSETS.hero,
    targetCategory: "cold-brews-black",
  },
  {
    id: "matcha",
    title: "Matcha",
    description: "Whisked clouds of green, balanced and bright.",
    image: ASSETS.pendant,
    targetCategory: "matcha",
  },
  {
    id: "sandwiches",
    title: "Sandwiches",
    description: "Open toasts, melts and our forest truffle ritual.",
    image: ASSETS.cookies,
    targetCategory: "sandwiches",
  },
  {
    id: "pasta",
    title: "Pasta",
    description: "White, green and red sauces — comfort, plated.",
    image: ASSETS.interior,
    targetCategory: "pasta",
  },
  {
    id: "frappes",
    title: "Frappes",
    description: "Blended, frosty, and impossible to stop sipping.",
    image: ASSETS.hero,
    targetCategory: "frappes",
  },
  {
    id: "shakes",
    title: "Shakes",
    description: "Nutella, Biscoff, Oreo — childhood in a glass.",
    image: ASSETS.cookies,
    targetCategory: "shakes",
  },
  {
    id: "bakery",
    title: "Bakery & Desserts",
    description: "Croissants, cookies, Korean buns and tres leches.",
    image: ASSETS.cookies,
    targetCategory: "bakery",
  },
  {
    id: "fries",
    title: "Fries & Sides",
    description: "Baked, loaded, never boring.",
    image: ASSETS.cookies,
    targetCategory: "baked-fries",
  },
  {
    id: "non-coffee",
    title: "Non-Coffee Drinks",
    description: "Hibiscus, iced teas and quiet single-origins.",
    image: ASSETS.pendant,
    targetCategory: "non-coffee",
  },
];

export const MENU = [
  {
    id: "hot-brews",
    title: "Hot Brews",
    items: [
      { name: "Vanilla Latte", desc: "Espresso softened with vanilla for a smooth, comforting finish.", price: 260 },
      { name: "Hazelnut Latte", desc: "Nutty sweetness meets bold coffee in perfect balance.", price: 260 },
    ],
  },
  {
    id: "cold-brews-black",
    title: "Cold Brews — Black",
    items: [
      { name: "Iced Espresso", desc: "Bold espresso on the rocks — chilly but still feisty.", price: 190 },
      { name: "Iced Americano", desc: "A cool, refreshing 'I've got this' kind of coffee.", price: 210 },
      { name: "Iced Pour Over", desc: "Crisp, bright, and beautifully chilled.", price: 240 },
      { name: "Coffee Tonic", desc: "Zesty tonic meets espresso for a fizzy caffeine high-five.", price: 280, signature: true },
      { name: "Iced Coconut Espresso", desc: "Tropical vacation meets strong coffee.", price: 250 },
      { name: "Orange Espresso", desc: "Citrus and coffee doing a surprisingly good duet.", price: 280 },
    ],
  },
  {
    id: "cold-brews-white",
    title: "Cold Brews — White",
    items: [
      { name: "Cold Brew", desc: "Smooth, slow-steeped, and dangerously easy to sip.", price: 220 },
      { name: "Iced Latte", desc: "Chilled, creamy, and endlessly comforting.", price: 250 },
      { name: "Vanilla Iced Latte", desc: "Cool, creamy, and effortlessly refreshing.", price: 270 },
      { name: "Hazelnut Iced Latte", desc: "A chilled nutty delight with a caffeine kick.", price: 270 },
      { name: "Iced Mocha", desc: "Chocolate + ice + coffee = instant happiness.", price: 280 },
      { name: "Vietnamese Iced Coffee", desc: "Strong, sweet, and addictive.", price: 270 },
      { name: "Cold Coffee", desc: "Classic, creamy, and nostalgic.", price: 270 },
      { name: "Iced Cappuccino", desc: "Foamy, icy, and full of personality.", price: 260 },
      { name: "Trioccino", desc: "Cold brew + espresso + instant coffee with ice cream.", price: 310, signature: true },
      { name: "Affogato", desc: "Chocolate or vanilla ice cream drowned in espresso.", price: 280 },
    ],
  },
  {
    id: "matcha",
    title: "Matcha",
    items: [
      { name: "Hot Matcha", desc: "Stone-ground, whisked slow, ceremonial calm.", price: 300 },
      { name: "Cold Matcha with Strawberry / Crush", desc: "Earthy green meets summer fruit.", price: 320 },
      { name: "Mango Matcha", desc: "Tropical mango meets earthy matcha in a vibrant fusion.", price: 380 },
      { name: "Coconut Matcha Cloud", desc: "Tropical, dreamy, drinkable cloud.", price: 380, signature: true },
    ],
  },
  {
    id: "frappes",
    title: "Frappes",
    items: [
      { name: "Vanilla Frappe", desc: "Creamy vanilla bliss blended into an icy cloud of happiness.", price: 300 },
      { name: "Hazelnut Frappe", desc: "Nutty, smooth, and impossible to stop sipping.", price: 290 },
      { name: "Cinnamon Frappe", desc: "A cozy cinnamon hug served ice-cold.", price: 290 },
      { name: "Chocolate Frappe", desc: "Rich chocolate indulgence with every frosty swirl.", price: 310 },
    ],
  },
  {
    id: "shakes",
    title: "Shakes",
    items: [
      { name: "Nutella Shake", desc: "Chocolate and hazelnut living their best life together.", price: 240 },
      { name: "Oreo Cookies Shake", desc: "Cookies, cream, and childhood nostalgia in a glass.", price: 220 },
      { name: "Biscoff Shake", desc: "Caramelised cookie magic blended to perfection.", price: 290 },
      { name: "Strawberry Shake", desc: "Sweet, fruity, and refreshingly pink.", price: 240 },
      { name: "Mango Shake", desc: "Sunshine, mangoes, and summer in every sip.", price: 300 },
    ],
  },
  {
    id: "milk-add-ons",
    title: "Milk Add Ons",
    items: [
      { name: "Lactose Free", desc: "Smoother on the stomach.", price: 50 },
      { name: "Cashew & Oat", desc: "Creamy, nutty, plant-based.", price: 60 },
      { name: "Almond", desc: "Light, toasty, classic.", price: 80 },
    ],
  },
  {
    id: "sides",
    title: "Sides",
    items: [
      { name: "Garlic Bread", desc: "Buttery, herby, eternally welcome.", price: 200 },
      { name: "Garlic Bread with Cheese", desc: "More cheese, more reason.", price: 250 },
      { name: "Chilli Cheese Toast", desc: "Spicy, gooey, gloriously messy.", price: 280 },
      { name: "Nachos (Salsa / Cheese)", desc: "Crunch, dip, repeat.", price: "200 / 250" },
      { name: "Loaded Nachos", desc: "Cheese, salsa, jalapeños — the works.", price: 380 },
      { name: "Guacamole with Nachos Chips", desc: "Creamy avocado, lime, sea salt, and crunch.", price: 300 },
      { name: "Maggi (Plain)", desc: "Comfort food, café upgrade.", price: 120 },
      { name: "Maggi with Cheese", desc: "Slow-melted cheese meets midnight-snack classic.", price: 150 },
      { name: "Maggi with Vegetables & Cheese", desc: "Loaded, cheesy, and quietly wholesome.", price: 180 },
    ],
  },
  {
    id: "baked-fries",
    title: "Baked Fries",
    items: [
      { name: "Salted Fries", desc: "Honest, hot, and crisp.", price: 200 },
      { name: "Peri Peri Fries", desc: "A little fire, a lot of flavour.", price: 220 },
      { name: "Cheese Fries", desc: "Molten cheese on every fry.", price: 250 },
      { name: "Loaded Fries", desc: "Everything, everywhere, all at once.", price: 280 },
    ],
  },
  {
    id: "sandwiches",
    title: "Sandwiches",
    items: [
      { name: "Avocado Open Toast", desc: "Smashed avo, sea salt, sourdough.", price: 420 },
      { name: "Forest Truffle Mushroom Melt", desc: "Earthy mushrooms, truffle oil, slow-melted cheese.", price: 420, signature: true },
      { name: "Pesto Tomato Open Toast", desc: "Basil pesto, heirloom tomato, fresh herbs.", price: 400 },
      { name: "Caprese Sandwich", desc: "Mozzarella, tomato, basil — the Italian love language.", price: 300 },
      { name: "Feta Croissant Sandwich", desc: "Buttery croissant, salty feta, sun-warmed veggies.", price: 400 },
    ],
  },
  {
    id: "pasta",
    title: "Pasta",
    items: [
      { name: "Spaghetti Aglio Olio", desc: "Garlic, chilli, olive oil — restraint as flavour.", price: 450 },
      { name: "Alfredo Pasta", desc: "Velvet white sauce, generous parmesan.", price: 480, signature: true },
      { name: "Pesto Pasta", desc: "Fresh basil pesto, pine-nut whispers.", price: 480 },
      { name: "Pomodoro Pasta", desc: "Slow-cooked tomato, basil, simplicity.", price: 480 },
    ],
  },
  {
    id: "bakery",
    title: "Bakery & Desserts",
    items: [
      { name: "Butter Croissant", desc: "Golden, flaky, and unapologetically buttery.", price: 180 },
      { name: "Chocolate Croissant", desc: "Warm dark chocolate folded into buttery layers.", price: 200 },
      { name: "Almond Croissant", desc: "Toasted almond cream, powdered sugar, quiet luxury.", price: 280 },
      { name: "Korean Bun", desc: "Soft, milky, dangerously pillowy.", price: 300 },
      { name: "Choco Chip Cookies", desc: "Chewy centres, crisp edges, chocolate everywhere.", price: 165 },
      { name: "Nutella Cookies", desc: "Molten hazelnut heart in every bite.", price: 200 },
      { name: "Triple Chocolate Cookies", desc: "Dark, milk, white — the full chocolate lineup.", price: 230 },
      { name: "Tres Leches", desc: "Three-milk soaked sponge, cool and dreamy.", price: 400 },
    ],
  },
  {
    id: "non-coffee",
    title: "Non-Coffee",
    items: [
      { name: "Peach Iced Tea", desc: "Sun-tea slow, peach-sweet finish.", price: 200 },
      { name: "Iced Tea", desc: "Classic, refreshing, unfussy.", price: 200 },
      { name: "Cascara Hibiscus", desc: "Coffee cherry husk + hibiscus bloom.", price: 350 },
      { name: "Vahdam Tea", desc: "Estate-sourced single-origin teas.", price: 150 },
    ],
  },
];

export const SIGNATURE_PICKS = [
  { name: "Coffee Tonic", note: "Fizzy. Citrusy. Unexpected." },
  { name: "Trioccino", note: "Three coffees, one revelation." },
  { name: "Coconut Matcha Cloud", note: "A tropical pause." },
  { name: "Forest Truffle Mushroom Melt", note: "Earthy & indulgent." },
  { name: "Alfredo Pasta", note: "Velvet white-sauce comfort." },
];
